import styled, { keyframes } from 'styled-components';

const animation = keyframes`
  0% {
    bottom: -100%;
  }
  65% {
    bottom: 4px;
  }
  100% {
    bottom: -3px;
  }
`;

export const Wrapper = styled.div`
  width: 120px;
  display: flex;
  justify-content: center;
  position: relative;
  overflow: hidden;
`;

export const SnappyAnimation = styled.img`
  position: relative;
  bottom: -3px;
  width: 88px;
  height: 80px;
  z-index: 1;
  margin-left: 7px;
  animation: ${animation} 0.65s ease-out;
`;

export const LeftHand = styled.img`
  position: absolute;
  bottom: 3px;
  left: 13px;
  width: 16px;
  height: 8px;
  z-index: 3;
`;

export const RightHand = styled.img`
  position: absolute;
  bottom: 3px;
  right: 15px;
  width: 16px;
  height: 8px;
  z-index: 3;
`;
